<script setup lang="ts">
import { ref, computed, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import DateInput from '@/components/Global/DateInput.vue';
import { getAsset } from '@/helpers/assetsUtils';

const props = defineProps({
  dateFrom: { type: Date, required: true },
  dateTo: { type: Date, required: true },
  passengers: { type: Number, required: true },
  passengersOptions: { type: Array as () => number[], default: () => [] },
  disabledDates: {type: Boolean, default: false},
  windowWidth: { type: Number, default: window.innerWidth }
});

const emit = defineEmits(['update:dateFrom', 'update:dateTo', 'update:passengers']);
const { t } = useI18n();

const localDateFrom = computed({
  get: () => props.dateFrom,
  set: val => emit('update:dateFrom', val)
});

const localDateTo = computed({
  get: () => props.dateTo,
  set: val => emit('update:dateTo', val)
});

const localPassengers = computed({
  get: () => props.passengers,
  set: val => emit('update:passengers', val)
});

// Chevron icon toggle
const isMenuOpen = ref(false);
const chevronIcon = computed(() =>
    isMenuOpen.value ? getAsset('icons', 'Up_16x16.svg') : getAsset('icons', 'Down_16x16.svg')
);

// Responsive DateInput
const columns = computed(() => {
  if (props.windowWidth < 768) return 1;
  if (props.windowWidth < 1111) return 2;
  if (props.windowWidth < 1480) return 1;
  if (props.windowWidth > 1481) return 2;
  return 1;
});

const calendarClass = computed(() => {
  if (props.windowWidth < 400) return "scale-[0.80]";
  if (props.windowWidth < 1024) return "scale-[1.00]";
  if (props.windowWidth < 1336) return "scale-[0.90]";
  return "scale-[1.00]";
});
</script>

<template>
  <div class="flex flex-col sm:flex-row gap-4 mt-2">
    <!-- When Section -->
    <div class="flex flex-col sm:w-3/4">
      <div class="date-subtitle responsive-body-small flex gap-1.5 opacity-60">
        <img src="@/assets/icons/svg/Calendar_16x16.svg" alt="calendar" />
        <span>{{ t('when') }}</span>
      </div>
      <div>
        <DateInput
            v-model:dateFrom="localDateFrom"
            v-model:dateTo="localDateTo"
            :show-tabs="false"
            :columns="columns"
            :rows="1"
            :calendarClass="calendarClass"
            :disabled="disabledDates"
        />
      </div>
    </div>

    <!-- Passengers Section -->
    <div class="flex flex-col sm:w-1/4">
      <div class="passengers-subtitle responsive-body-small flex gap-1.5 opacity-60">
        <img src="@/assets/icons/svg/Guest_16x16.svg" alt="guests" />
        <span>{{ t('passengers') }}</span>
      </div>
      <div>
        <v-select
            variant="underlined"
            v-model="localPassengers"
            :items="passengersOptions"
            menu-icon="null"
            @update:menu="isMenuOpen = $event"
        >
          <template v-slot:append-inner>
            <img
                :src="chevronIcon"
                class="w-4 h-4 transition-transform duration-200"
                alt="chevron"
            />
          </template>
        </v-select>
      </div>
    </div>
  </div>
</template>


<style scoped>

</style>